import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PartnerProfilePage.module.scss';
import clsx from 'clsx';
import ProfileBlock from '../../components/ProfileBlock/ProfileBlock';
import Layout from '../../components/Layout/Layout';
import Row from '../../components/Row/Row';
import Block from '../../components/Block/Block';
import Button from '../../components/Button/Button';
import { useForm } from 'react-hook-form';
import Input from '../../components/Input/Input';
import Alert from '../../components/Alert/Alert';
import { userMe } from '../../redux/actions/user/userMe';
import { serviceUpdate } from '../../redux/actions/service/serviceUpdate';
import Swal from 'sweetalert2';
import { gamePartnerSwitchActive } from '../../redux/actions/game/gamePartnerSwitchActive';
import { serviceSwitchActive } from '../../redux/actions/service/serviceSwtichActive';
import { serviceGenerateKey } from '../../redux/actions/service/serviceGenerateKey';
import withReactContent from 'sweetalert2-react-content';
import Code from '../../components/Code/Code';
import { resetServiceGenerateKey } from '../../redux/slices/service.slice';
const ReactSwal = withReactContent(Swal);
const PartnerProfilePage = () => {
  const form = useForm();
  const onSubmit = (data) => {
    dispatch(serviceUpdate(data));
  };
  const rulesIp = {
    required: { value: true, message: 'Обязательно поле' },
    pattern: {
      value: /^((25[0-5]|(2[0-4]|1\d|[1-9])?\d)\.?\b){4}$/,
      message: 'Неверный формат IP адреса',
    },
  };
  const rulesSite = {
    required: { value: true, message: 'Обязательно поле' },
    pattern: {
      value: /^(https?:\/\/)?([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/,
      message: 'Введите адрес по такого вида - domain.com или https://domain.com',
    },
  };
  const dispatch = useDispatch();
  const {
    userMe: { data: userMeData, loading: userMeLoading, error: userMeError },
  } = useSelector((state) => state.user);
  useEffect(() => {
    const values = form.getValues();
    if (userMeData && !values?.ip && !values?.site && !values?.name) {
      form.setValue('ip', userMeData?.service?.ip);
      form.setValue('site', userMeData?.service?.site);
      form.setValue('name', userMeData?.service?.name);
    }
  }, [userMeData]);

  const {
    serviceUpdate: { data: serviceUpdateData, loading: serviceUpdateLoading, error: serviceUpdateError },
    serviceGenerateKey: { data: serviceGenerateKeyData, loading: serviceGenerateKeyLoading, error: serviceGenerateKeyError },
  } = useSelector((state) => state.service);

  const {
    serviceSwitchActive: { data: serviceSwitchActiveData, loading: serviceSwitchActiveLoading, error: serviceSwitchActiveError },
  } = useSelector((state) => state.service);
  const onServiceActive = () => {
    Swal.fire({
      title: `Вы уверены что хотите ${userMeData?.service?.active ? 'отключить' : 'включить'} сервис`,
      showCancelButton: true,
      showConfirmButton: true,
      background: '#fff',
      cancelButtonColor: '#fc564a',
      cancelButtonText: 'Отмена',
      confirmButtonColor: '#65c15c',
      confirmButtonText: userMeData?.service?.active ? 'Отключить' : 'Включить',
    }).then((data) => {
      if (data.isConfirmed) {
        dispatch(serviceSwitchActive());
      }
    });
  };
  useEffect(() => {
    if (serviceGenerateKeyData) {
      dispatch(userMe());
      ReactSwal.fire({
        title: `Новый приватный ключ сгенерирован`,
        width: '600px',
        html: (
          <>
            <div className={clsx(styles.warningText)}>
              Сохраните приватный ключ в надежное место. <br /> Ключ будет показан <b>только один раз!</b>
            </div>
            <Code>{serviceGenerateKeyData?.privateKey}</Code>
          </>
        ),
        icon: 'success',
        showCancelButton: true,
        showConfirmButton: false,
        background: '#fff',
        cancelButtonColor: '#fc564a',
        cancelButtonText: 'Закрыть',
      }).then((data) => {});
      dispatch(resetServiceGenerateKey());
    }
  }, [serviceGenerateKeyData]);

  const onGeneratePassword = () => {
    Swal.fire({
      icon: 'question',
      title: `Вы уверены что хотите сгенерировать новый приватный ключ ?`,
      showCancelButton: true,
      showConfirmButton: true,
      background: '#fff',
      cancelButtonColor: '#fc564a',
      cancelButtonText: 'Отмена',
      confirmButtonColor: '#65c15c',
      confirmButtonText: 'Сгенерировать',
    }).then((data) => {
      if (data.isConfirmed) {
        dispatch(serviceGenerateKey());
      }
    });
  };
  useEffect(() => {
    if (serviceUpdateData) {
      dispatch(userMe());
    }
  }, [serviceUpdateData]);
  useEffect(() => {
    if (serviceSwitchActiveData) {
      dispatch(userMe());
    }
  }, [serviceSwitchActiveData]);

  return (
    <>
      <Layout>
        <div className="wrap">
          {userMeData?.service?.active ? (
            <Alert type="success">
              <b>Сервис активен</b>
            </Alert>
          ) : (
            <Alert type="error">
              <b>Сервис неактивен.</b> {userMeData?.service?.isFirstActive ? '' : 'Заполните данные вашего сервиса для активации'}
            </Alert>
          )}

          <ProfileBlock>
            <Row label="Shop ID" value={userMeData?.service?.shopId} />
            <Row
              label="Private key"
              value={
                !userMeData?.service?.privateKeyEnd && !userMeData?.service?.privateKeyStart ? (
                  <Button
                    onClick={() => {
                      dispatch(serviceGenerateKey());
                    }}
                    rightIcon={
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-key">
                        <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>
                      </svg>
                    }>
                    Сгенерировать ключ
                  </Button>
                ) : (
                  `${userMeData?.service?.privateKeyStart}******${userMeData?.service?.privateKeyEnd}`
                )
              }
            />
            {userMeData?.service?.privateKeyEnd && userMeData?.service?.privateKeyStart && (
              <Button
                onClick={onGeneratePassword}
                rightIcon={
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-refresh-cw">
                    <polyline points="23 4 23 10 17 10"></polyline>
                    <polyline points="1 20 1 14 7 14"></polyline>
                    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                  </svg>
                }>
                Сгенерировать новый ключ
              </Button>
            )}
          </ProfileBlock>
          <Block title="Данные вашего сервиса" className={styles.service}>
            <div className={clsx(styles.serviceContent)}>
              <Input className={clsx(styles.inputEmail)} name="name" form={form} label="Имя сервиса" /> <Input className={clsx(styles.inputEmail)} name="site" form={form} label="Адрес сайта" rules={rulesSite} />{' '}
              <Input className={clsx(styles.inputEmail)} name="ip" form={form} label="IP сервера" rules={rulesIp} />
              <div className={clsx(styles.actions)}>
                {' '}
                <Button onClick={form.handleSubmit(onSubmit)}>Сохранить</Button>
                {userMeData?.service?.isFirstActive && (
                  <>
                    {userMeData?.service?.active ? (
                      <Button
                        onClick={onServiceActive}
                        className={clsx(styles.btnActive)}
                        type="danger"
                        rightIcon={
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-power">
                            <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
                            <line x1="12" y1="2" x2="12" y2="12"></line>
                          </svg>
                        }>
                        Отключить
                      </Button>
                    ) : (
                      <Button
                        onClick={onServiceActive}
                        type="success"
                        className={clsx(styles.btnActive)}
                        rightIcon={
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-power">
                            <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
                            <line x1="12" y1="2" x2="12" y2="12"></line>
                          </svg>
                        }>
                        Включить
                      </Button>
                    )}
                  </>
                )}
              </div>
            </div>
          </Block>
        </div>
      </Layout>
    </>
  );
};

export default PartnerProfilePage;
